import { FormControl, MenuItem, Select } from "@mui/material";
import React from "react";
import { setPackageData } from "../reducer/tourReducer";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../app/store";
import Navbar from "../components/Navbar";
import TourManagementOptionsSidebar from "../components/tour/TourManagementSidebarOptionsSidebar";
import InfoCardLightening from "../components/tour/InfoCardLightening";
import { useNavigate } from "react-router-dom";
import { Paths } from "../router/Paths";

const cutoffOptions = ["30m - 1 hour", "3 hours", "1 day", "2 days", "3 days"];
const TourManagementCutOffPage = () => {
  const { packageData } = useSelector((state: RootState) => state.tour);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onContinue = () => {
    navigate(Paths.tourManagementPackageOptionsSetup);
  };
  return (
    <div className={Classname.container}>
      <Navbar />
      <div className={Classname.content}>
        <TourManagementOptionsSidebar selected={5} />

        <div className="p-10">
          <div className={Classname.title}>Set Your Cut-off time</div>
          <div className="mt-5 mb-8">
            The cut-off time is the latest you accept new bookings before the
            activity starts.
          </div>
          {/* <div className={Classname.description}>
            Having a cut-off time of 30 minutes or fewer can lead to 50% more
            bookings.
          </div> */}
          <div className={Classname.title}>
            How far in advance do you stop accepting new bookings before the
            activity starts?
          </div>
          <div className="w-80 mb-4">
            <FormControl fullWidth>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={packageData.cuttoff}
                onChange={(e) => {
                  dispatch(
                    setPackageData({
                      cuttoff: e.target.value,
                    })
                  );
                }}
              >
                {cutoffOptions?.map((option, index) => (
                  <MenuItem value={option} key={index}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <InfoCardLightening
            description={
              <div className="flex flex-col gap-1">
                <span>
                  Setting a lower cut-off time can capture last minute bookings
                  and drive more sales for your product.
                </span>
              </div>
            }
          />
        </div>
      </div>
      <div className={Classname.buttonsContainer}>
        <button className={Classname.continueButton} onClick={onContinue}>
          Continue
        </button>
      </div>
    </div>
  );
};

export default TourManagementCutOffPage;
const Classname = {
  container:
    "flex w-full min-h-screen relative bg-white flex-col items-center font-main",
  content:
    "flex flex-col lg:flex-row w-full max-w-7xl flex-1 pt-10 lg:pt-0 px-3 sm:px-10",
  detail: "flex flex-col py-10 px-3 lg:px-6 w-full",
  title: "font-bold text-lg mt-6 mb-2",
  input: "flex w-full h-14 border border-gray-400 rounded-md px-4 mt-2",
  textarea:
    "flex w-full h-44 py-4 border border-gray-400 rounded-md px-4 mt-2 mb-6 ",
  description: "flex text-base mb-4 mt-2",
  buttonsContainer: "flex flex-1 justify-end gap-3 mt-10",
  addressButton:
    "font-bold w-fit flex items-center gap-2 cursor-pointer text-primary1 py-3 px-3 border rounded-lg",
  saveButton:
    "h-12 px-6 flex items-center justify-center font-bold text-gray-700 border border-gray-500 rounded-md",
  continueButton:
    "h-12 px-6 flex items-center justify-center text-white font-bold bg-primary1 rounded-md",
};
